import { ReactElement } from 'react';

import withIcon from '../withIcon';

const Cars = (): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 99.088 99.087"
    >
      <g>
        <g>
          <path
            d="M15.078,51.768c-5.832,0-10.562,4.728-10.562,10.562c0,0.451,0.037,0.891,0.094,1.328
			c0.655,5.205,5.086,9.233,10.468,9.233c5.526,0,10.058-4.25,10.516-9.66c0.024-0.298,0.045-0.597,0.045-0.901
			C25.639,56.496,20.911,51.768,15.078,51.768z M11.107,59.339l1.617,1.618c-0.126,0.216-0.225,0.449-0.287,0.697h-2.28
			C10.274,60.792,10.605,60.002,11.107,59.339z M10.147,63.029h2.298c0.064,0.245,0.16,0.475,0.287,0.688l-1.621,1.621
			C10.609,64.675,10.27,63.889,10.147,63.029z M14.392,67.255c-0.859-0.12-1.641-0.457-2.301-0.956l1.611-1.611
			c0.213,0.125,0.445,0.215,0.689,0.277L14.392,67.255L14.392,67.255z M14.392,59.691c-0.251,0.063-0.483,0.164-0.701,0.292
			l-1.615-1.617c0.664-0.504,1.452-0.838,2.316-0.958V59.691z M15.766,57.409c0.864,0.12,1.653,0.454,2.316,0.959l-1.616,1.616
			c-0.216-0.128-0.451-0.229-0.7-0.292V57.409z M15.766,67.253v-2.288c0.244-0.062,0.475-0.155,0.688-0.279l1.612,1.612
			C17.406,66.797,16.623,67.133,15.766,67.253z M19.049,65.342l-1.626-1.627c0.128-0.214,0.23-0.44,0.295-0.687h2.28
			C19.875,63.887,19.552,64.683,19.049,65.342z M17.721,61.655c-0.063-0.249-0.162-0.481-0.287-0.697l1.618-1.618
			c0.5,0.664,0.831,1.452,0.949,2.315H17.721z"
          />
          <path
            d="M80.286,51.768c-5.831,0-10.562,4.728-10.562,10.562c0,0.451,0.037,0.891,0.095,1.328
			c0.655,5.205,5.085,9.233,10.467,9.233c5.527,0,10.06-4.25,10.517-9.66c0.023-0.298,0.045-0.597,0.045-0.901
			C90.848,56.496,86.12,51.768,80.286,51.768z M76.315,59.339l1.618,1.618c-0.127,0.216-0.226,0.449-0.289,0.697h-2.278
			C75.483,60.792,75.813,60.002,76.315,59.339z M75.356,63.029h2.298c0.062,0.245,0.16,0.475,0.287,0.688l-1.622,1.621
			C75.817,64.675,75.479,63.889,75.356,63.029z M79.6,67.255c-0.858-0.12-1.641-0.457-2.301-0.956l1.612-1.611
			c0.212,0.125,0.444,0.215,0.688,0.277V67.255L79.6,67.255z M79.6,59.691c-0.25,0.063-0.482,0.164-0.7,0.292l-1.615-1.617
			c0.664-0.504,1.452-0.838,2.315-0.958V59.691z M80.975,57.409c0.865,0.12,1.652,0.454,2.315,0.959l-1.614,1.616
			c-0.218-0.128-0.453-0.229-0.701-0.292V57.409z M80.975,67.253v-2.288c0.244-0.062,0.476-0.155,0.688-0.279l1.613,1.612
			C82.615,66.797,81.832,67.133,80.975,67.253z M84.258,65.342l-1.627-1.627c0.129-0.214,0.23-0.44,0.297-0.687h2.278
			C85.084,63.887,84.762,64.683,84.258,65.342z M82.93,61.655c-0.063-0.249-0.162-0.481-0.287-0.697l1.619-1.618
			c0.5,0.664,0.83,1.452,0.947,2.315H82.93z"
          />
          <path
            d="M75.914,26.198l-28.335,0.357c-0.85,0.01-1.53,0.708-1.519,1.558c0.009,0.837,0.688,1.509,1.52,1.519
			c0.014,0,0.025,0,0.038,0l28.335-0.357c0.85-0.01,1.53-0.708,1.52-1.558C77.461,26.867,76.74,26.166,75.914,26.198z"
          />
          <path
            d="M64.707,62.041H31.253c-0.85,0-1.538,0.689-1.538,1.539c0,0.851,0.688,1.539,1.538,1.539h33.454
			c0.85,0,1.538-0.688,1.538-1.539C66.245,62.73,65.557,62.041,64.707,62.041z"
          />
          <path
            d="M98.658,53.259c-0.357-0.436-0.895-0.688-1.458-0.688h-1.749l-1.777-19.458c-0.098-1.074-1.006-1.891-2.086-1.875
			l-50.028,0.75c-0.778,0.012-1.51,0.376-1.988,0.991l-6.631,8.523l-21.714,1.345c-1.181,0.074-2.262,0.689-2.926,1.668
			l-1.223,1.799c0,0-2.094,0.737-2.655,1.201c-0.487,0.403-1.456,2.069-1.456,2.069c-0.184,0.26-0.206,0.603-0.059,0.884
			c0.146,0.283,0.438,0.46,0.757,0.46v1.896H1.858C0.831,52.825,0,53.657,0,54.682v3.424c0,1.272,1.031,2.305,2.305,2.305H3.54
			l3.183-8.782c0.29-0.8,1.05-1.333,1.9-1.333h11.11c0.63,0,1.225,0.294,1.607,0.796l7.484,9.824h39.064l5.482-9.25
			c0.363-0.614,1.023-0.99,1.738-0.99h10.201c0.72,0,1.385,0.383,1.748,1.005l5.375,9.236h1.928c2.027,0,3.773-1.435,4.165-3.425
			l0.524-2.666C99.162,54.271,99.018,53.697,98.658,53.259z M51.068,43.467H39.54v-3.541h-2.335l3.494-4.613
			c0.15-0.199,0.384-0.317,0.633-0.321l11.694-0.174v5.108L51.068,43.467z M70.131,43.467H57.699v-8.719l14.993-0.223v6.38
			L70.131,43.467z M76.538,43.467v-9l12.907-0.192c0.22-0.003,0.402,0.166,0.419,0.385l0.606,8.807H76.538z"
          />
        </g>
      </g>
    </svg>
  );
};

export default withIcon(Cars);
